import React from 'react';
import { IProps } from './component';
import { Form, Checkbox, Select } from 'antd'
const { Option } = Select;

export const DocumentCollector = (props: IProps) => {
    // const properties = props.json.properties;

    // const docsCollector = [
    //     {
    //         id: "idProofs",
    //         category: "ID Proofs",
    //         options: [
    //             { label: "Aadhar", value: "aadhar" },
    //             { label: "Driving License", value: "drivingLicense" },
    //             { label: "PAN", value: "panImg" },
    //             { label: "Passport", value: "passport" },
    //             { label: "VoterId", value: "voterId" }
    //         ],
    //         displayNameMap: {
    //             aadhar: "Aadhar",
    //             drivingLicense: "Driving License",
    //             panImg: "PAN",
    //             passport: "Passport",
    //             voterId: "Voter Id"
    //         }
    //     },
    //     {
    //         id: "salaryProofs",
    //         category: "Salary Proofs",
    //         options: [
    //             { label: "Payslip", value: "payslip" },
    //             { label: "Bank Statement", value: "bankStatement" },
    //             { label: "Single KYC Approval", value: "singleKYCApproval" }
    //         ],
    //         displayNameMap: {
    //             payslip: "Payslip",
    //             bankStatement: "Bank Statement",
    //             singleKYCApproval: "Single KYC Approval"
    //         }
    //     }
    // ]
    const docsCollector = props.json.data && props.json.data.preload && props.json.data.preload.bindParams && props.json.data.preload.bindParams
    return (
        <React.Fragment>
            <div>
                <>
                    {docsCollector ? docsCollector.map((docs: any, i: number) => (
                        <Form.Item
                            key={i}
                            label={docs.category}
                            className='override-common'
                        >
                            <div className="row" >
                                <div className="form-group col-xs-8 col-md-8">
                                    <Checkbox.Group
                                        style={{ paddingLeft: "12px" }}
                                        className="kyc-Option-checkBox"
                                        options={docs.options}
                                    // value={
                                    //     documentCollectorData &&
                                    //     documentCollectorData.value[docs.id] &&
                                    //     documentCollectorData.value[docs.id].docs.map((x: any) => x.variable)
                                    // }
                                    // onChange={values => this.handleKycDocsSelect(values, docs.id, docs.displayNameMap)}
                                    />
                                </div>
                                <div className="form-group col-xs-4 col-md-4">
                                    <Form.Item label={"Minimum required"}>
                                        <Select
                                            style={{ width: 200 }}
                                            // value={
                                            //     documentCollectorData &&
                                            //     documentCollectorData.value[docs.id] &&
                                            //     documentCollectorData.value[docs.id].minReq
                                            // }
                                            dropdownClassName='select-dropdown'
                                            placeholder="Minimum required"
                                        // onChange={(value: any) => this.handleKycMinReqSelect(docs.id, value)}
                                        >
                                            {
                                                new Array(docs.options.length).fill(0).map((dummy, index) => {
                                                    return <Option data-test-id={`doc_${index + 1}`} value={index + 1} key={index}>{index + 1}</Option>;
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </Form.Item>
                    )) : <div>
                        <h6 style={{ color: 'rgba(0,0,0,0.3)', fontSize: '14px' }}>Please add Datas from data tab</h6>
                    </div>}
                    {/* <DocumentCollectorManupulation
                        taskInfo={this.props.taskInfo}
                        ipc={this.props.postMessage}
                        hostUrl={"https://hdfc-staging.autonom8.com"}
                        docsDetails={docsCollector && docsCollector.map((doc: any) => {
                            return {
                                category: doc.category,
                                docVarsDetails:
                                    documentCollectorData && documentCollectorData.value[doc.id] ? documentCollectorData.value[doc.id].docs : [],
                                minRequired:
                                    documentCollectorData && documentCollectorData.value[doc.id] ? documentCollectorData.value[doc.id].minReq : 0
                            };
                        })}
                        label="Customer's documents"
                    /> */}

                </>
            </div>
        </React.Fragment>
    )
}
